<template>
    <div class="wrapperHeader">
        <div class="container">
            <div class="colLabel">
                <h1>Кабинет <br>ERP AlfaDiesel</h1>
            </div>
            <a class="colLogo" href="/">
                <img alt="Work Alfa Diesel" :src="'/img/favicon.png'">
            </a>
            <div class="colMenu">
                <div class="btnOpenMenu" :class="{active: mobile.active}" @click="showMenuMobile()"><div class="btnMenu"><div></div><div></div><div></div></div></div>
            </div>
        </div>
    </div>
    <Transition name="opacity-with-slide-right">
        <div class="wrapperHeadMobile" v-if="mobile.active">
            <div class="contentHeaderMobile">
                <div class="rowMenuHeader">
                    <div class="colLogo"><img alt="Work Alfa Diesel" :src="'/img/favicon.png'"></div>
                    <div class="btnOpenMenu btnOpenMenuHeder" :class="{active: mobile.active}" @click="hideMenuMobile()"><div class="btnMenu"><div></div><div></div><div></div></div></div>
                </div>
                <div class="rowBody">
                    <div class="colMenu">
                        <Logout v-if="isAuthenticated"></Logout>
                        <router-link to="/login" v-if="!isAuthenticated">Login</router-link>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import Logout from '@/VueWorking/Pages/Logout.vue';

export default {
    name: 'HeaderPage',
    components: { Logout },
    data(){
        return {
            isAuthenticated: parseFloat(localStorage.authenticated),
            mobile: {
                active: false,
            }
        }
    },
    methods: {
        showMenuMobile(){ this.mobile.active = true },
        hideMenuMobile(){ this.mobile.active = false },
    }
}
</script>